import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CharterBuyflowVesselDetailComponent } from './charter-buyflow-vessel-detail.component';
import { MobileRequestBookingDialogModule } from '../../../shared/public-components/mobile-request-booking-dialog/mobile-request-booking-dialog.module';
import { CharterBuyflowVesselDetailResolve } from './charter-buyflow-vessel-detail.resolve';

@NgModule({
  imports: [
    MobileRequestBookingDialogModule,
    RouterModule.forChild([
      {
        path: '',
        component: CharterBuyflowVesselDetailComponent,
        resolve: {
          resolvedData: CharterBuyflowVesselDetailResolve,
        },
        data: {
          oauthFlow: false,
        },
      },
      {
        path: '',
        component: CharterBuyflowVesselDetailComponent,
        resolve: {
          resolvedData: CharterBuyflowVesselDetailResolve,
        },
        data: {
          oauthFlow: true,
        },
      },
      {
        path: '',
        component: CharterBuyflowVesselDetailComponent,
        resolve: {
          resolvedData: CharterBuyflowVesselDetailResolve,
        },
        data: {
          oauthFlow: false,
        },
      },
    ]),
  ],
  exports: [RouterModule],
  entryComponents: [],
})
export class CharterBuyflowVesselDetailRoutingModule {}
